import { Link } from 'react-router-dom';
import VitrineNav from './VitrineNav';
import './LandingPage.css';

export default function MentionsLegales() {
  return (
    <div className="vt">
      {/* ⚠️ CETTE PAGE N'AVAIT NI LOGO NI SIGNATURE GSS-360 (constat de Dom,
          09/10/2026). Sa barre portait un `<span>GSS-360</span>` NU — pas
          l'image de l'éditeur, pas la signature du produit — et se réduisait à
          « Retour à l'accueil / Se connecter ». Elle reçoit maintenant
          l'en-tête de l'accueil, au markup près.
          ⓘ Le retour à l'accueil n'est pas perdu : la marque elle-même mène
            à « / », et le lien `.vt-legal-back` juste en dessous le dit en
            mots.
          ⓘ Vérifié : `.vt-legal` porte `padding: 100px 24px 60px` et la barre
            est `position: fixed; height: 64px` — aucun recouvrement, donc
            aucune retouche de mise en page. */}
      <VitrineNav />

      <section className="vt-legal">
        <div className="vt-legal-content">
          <Link to="/" className="vt-legal-back">← Retour à l&apos;accueil</Link>
          <h1>Mentions légales</h1>
          <p className="vt-legal-sub">Informations légales relatives à l'éditeur de la plateforme GSS-360.</p>

          <h2>Éditeur</h2>
          <p>
            <strong>Gladiator Security Systems SARL</strong><br />
            Éditeur de GSS-360, intégrateur de systèmes de sécurité<br />
            Siège social : Tokoin-Wuiti, Rue Air-Burkina, Lomé, Togo
          </p>

          <h2>Immatriculation</h2>
          <p>
            RCCM : TG-LFW-01-2024-B13-00449<br />
            NIF : 1001930788
          </p>

          <h2>Directeur de la publication</h2>
          <p>SOMABEY Akoété Dominique, Directeur Général</p>

          <h2>Hébergement</h2>
          <p>
            AFRICLOUD — Lisbonne, Portugal<br />
            Domaine : gss360.net
          </p>

          <h2>Activité</h2>
          <p>
            GSS-360 est une plateforme SaaS de gestion intégrée destinée aux sociétés de sécurité privée
            en zone OHADA. Elle couvre la paie, la comptabilité SYSCOHADA, la supervision opérationnelle,
            la gestion RH et l'assistance par intelligence artificielle.
          </p>

          <h2>Contact</h2>
          <p>
            Pour toute question relative à ces mentions légales, contactez-nous via le
            {/* ⚠️ `<a href="/vitrine#demo">` ÉTAIT LA CAUSE, PAS L'ANCRE. Un lien
                plein recharge toute l'application, et au rechargement le
                navigateur traite le `#demo` AVANT que React ne monte : la
                section n'existe pas encore, donc aucun défilement. Le visiteur
                atterrissait en haut de l'accueil. En `<Link>`, la navigation
                reste côté client et `LandingPage` lit le hash. */}
            formulaire de <Link to="/#demo">demande de démonstration</Link>.
          </p>
        </div>
      </section>
    </div>
  );
}
